// extracted by mini-css-extract-plugin
export var button = "_m0-0";
export var donut = "_m0-1";
export var donutFill = "_m0-3";
export var donutTrack = "_m0-2";